import gql from 'graphql-tag'

export const GET_VEHICLE_VIDEO_LIST = gql`
  query VehicleVideoTrackers($filter: GetVehicleVideoTrackersInput) {
    vehicleVideoTrackers(filter: $filter) {
      isSuccessful
      message
      vehicleVideoTrackers {
        vehicleId
        companyId
        driverId
        motionStatus
        calculatedMotionStatus
        vehicle {
          id
          licensePlate
          imei
          hullNo
          device {
            deviceCode
            deviceName
            phoneNo
          }
          vehicleType {
            category
            manufacturer
            model
            type
            icon
          }
          driver1 {
            fullname
          }
        }
        statusText
      }
    }
  }
`

/**
 * Note : This query only used in page videoHistory3
 */
export const GET_VEHICLE_VIDEO_TRACKER_BY_VEHICLE_ID = gql`
  query VehicleVideoTrackers($filter: GetVehicleVideoTrackersInput) {
    vehicleVideoTrackers(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleVideoTrackers {
        vehicle {
          id
          companyId
          driver1Id
          driver2Id
          garageId
          tonnage
          volume
          fuelEfficiency
          fuelCapacity
          odometer
          status
          imei
          licensePlate
          vehicleTypeId
          sensor {
            sensorCode
            statusText
            __typename
          }
          device {
            deviceCode
            deviceName
            __typename
          }
          vehicleType {
            vehicleTypeId
            companyId
            isActive
            manufacturer
            model
            type
            category
            transmissionType
            fuelType {
              fuelTypeId
              name
              category
              __typename
            }
            tonnage
            volume
            fuelEfficiency
            icon
            hasRelation
            __typename
          }
          thermoType
          chassisNumber
          machineNumber
          carrosserie
          year
          hullNo
          idleDuration
          parkingDuration
          door1
          door2
          __typename
        }
        statusText
      }
    }
  }
`

export const SET_VIDEO_STREAM_STATUS = gql`
  mutation SetVideoStreamStatus($input: SetVideoStreamStatusInput!) {
    setVideoStreamStatus(input: $input) {
      isSuccessful
      message
      setVideoStreamStatus {
        imei
        status
        channelSent
        channelNotSent
      }
    }
  }
`

export const SET_VIDEO_STREAM_STATUS_OFF = gql`
  mutation SetVideoStreamStatusOff {
    setVideoStreamStatusOff {
      isSuccessful
      errorCode
      errorName
      message
      status
      setVideoStreamStatusOff {
        status
      }
    }
  }
`

export const GET_SIGNED_URL = gql`
  query GetSignedUrl($filter: GetSignedUrlInput) {
    getSignedUrl(filter: $filter) {
      getSignedUrl {
        url
      }
    }
  }
`
